/* ==========================================================
   maamii · Geschenkverpackung im Warenkorb
   Zeigt im Warenkorb-Drawer und auf der Warenkorbseite die Option
   «Als Geschenk verpacken» mit Feld für den Kartentext.
   Die Verpackung ist ein eigenes Produkt (Handle: geschenkverpackung),
   der Kartentext wird als Warenkorb-Attribut «Grusskarte» gespeichert
   und erscheint in der Bestellung unter «Zusätzliche Details».
   ========================================================== */
(function () {
  var W = window.mmWrap;
  if (!W || !W.id) return;

  var ATTR = 'Grusskarte';
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var LANG = (document.documentElement.lang || 'de').slice(0, 2);
  var T = {
    de: { wrap: 'Als Geschenk verpacken', card: 'Text für die Karte (optional)', ph: 'z. B. Alles Liebe zur Geburt!', saved: 'Gespeichert – dieser Text kommt auf die Karte.' },
    fr: { wrap: 'Emballer en cadeau', card: 'Texte pour la carte (facultatif)', ph: 'p. ex. Plein de bonheur pour la naissance !', saved: 'Enregistré – ce texte figurera sur la carte.' },
    en: { wrap: 'Wrap as a gift', card: 'Message for the card (optional)', ph: 'e.g. Congratulations on your new arrival!', saved: 'Saved – this message will go on the card.' }
  }[LANG] || null;
  if (!T) T = { wrap: 'Als Geschenk verpacken', card: 'Text für die Karte (optional)', ph: 'z. B. Alles Liebe zur Geburt!', saved: 'Gespeichert – dieser Text kommt auf die Karte.' };
  var cartReq = null;
  var busy = false;
  var uid = 0;

  function getCart(fresh) {
    if (fresh || !cartReq) {
      cartReq = fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }
    return cartReq;
  }
  function esc(s) {
    return String(s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function wrapLine(cart) {
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].variant_id === W.id) return cart.items[i];
    return null;
  }
  function otherCount(cart) {
    return cart.items.reduce(function (n, it) { return it.variant_id === W.id ? n : n + it.quantity; }, 0);
  }

  function makeBox(checked, msg) {
    var id = 'mm-gw-msg-' + (++uid);
    var el = document.createElement('div');
    el.className = 'mm-gw';
    el.setAttribute('data-mm-gw', '');
    el.innerHTML =
      '<label class="mm-gw__row">' +
        '<input type="checkbox" data-mm-gw-toggle' + (checked ? ' checked' : '') + '>' +
        '<span class="mm-gw__txt"><b>' + esc(T.wrap) + ' + ' + esc(W.price) + '</b>' +
        (W.hint ? '<small>' + esc(W.hint) + '</small>' : '') + '</span>' +
      '</label>' +
      '<div class="mm-gw__msg"' + (checked ? '' : ' hidden') + '>' +
        '<label for="' + id + '">' + esc(T.card) + '</label>' +
        '<textarea id="' + id + '" rows="3" maxlength="300" data-mm-gw-msg placeholder="' + esc(T.ph) + '">' + esc(msg) + '</textarea>' +
        '<div class="mm-gw__saved" aria-live="polite"></div>' +
      '</div>';
    return el;
  }

  /* Orte, an denen die Option erscheint */
  function hosts() {
    var list = [];
    var df = document.querySelector('cart-drawer .cart-drawer__footer');
    if (df) list.push({ host: df, before: df.querySelector(':scope > .totals') });
    var pf = document.querySelector('#main-cart-footer .cart__footer');
    if (pf) list.push({ host: pf, before: pf.firstElementChild });
    return list;
  }

  /* Drawer neu zeichnen, ohne ihn zu öffnen */
  function renderDrawer(res) {
    if (!res || !res.sections) return;
    var parse = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
    var d = document.getElementById('CartDrawer');
    if (d && res.sections['cart-drawer']) {
      var src = parse(res.sections['cart-drawer']).querySelector('#CartDrawer');
      if (src) d.innerHTML = src.innerHTML;
      var ov = document.getElementById('CartDrawer-Overlay');
      var drawer = document.querySelector('cart-drawer');
      if (ov && drawer && drawer.close) ov.addEventListener('click', drawer.close.bind(drawer));
    }
    var b = document.getElementById('cart-icon-bubble');
    if (b && res.sections['cart-icon-bubble']) {
      var bs = parse(res.sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (bs) b.innerHTML = bs.innerHTML;
    }
  }

  function setAttr(value) {
    var a = {}; a[ATTR] = value;
    return fetch('/cart/update.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ attributes: a }) })
      .then(function (r) { cartReq = null; return r.json(); });
  }

  function setWrap(on, box) {
    if (busy) return Promise.resolve();
    busy = true;
    if (box) box.classList.add('is-busy');
    var onPage = !!document.getElementById('main-cart-footer');
    var body = { sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname };
    var url;
    if (on) { url = '/cart/add.js'; body.items = [{ id: W.id, quantity: 1 }]; }
    else { url = '/cart/change.js'; body.id = String(W.id); body.quantity = 0; }

    return fetch(url, { method: 'POST', headers: JSONH, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        cartReq = null;
        var after = on ? Promise.resolve() : setAttr('');
        return after.then(function () {
          if (onPage) { location.reload(); return; }
          renderDrawer(res);
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof res.item_count === 'number') drawer.classList.toggle('is-empty', res.item_count === 0);
        });
      })
      .catch(function () { if (box) box.classList.remove('is-busy'); })
      .then(function () { busy = false; });
  }

  /* Zustand abgleichen: Option einsetzen, Häkchen setzen, verwaiste Verpackung entfernen */
  var syncTimer = null;
  function sync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      if (busy) return;
      var hs = hosts();
      if (!hs.length) return;
      /* Leerer Drawer und keine Warenkorbseite: nichts zu tun, keine Anfrage nötig */
      var dr = document.querySelector('cart-drawer');
      if (!document.getElementById('main-cart-footer') && dr && !dr.querySelector('.cart-item')) {
        var old = dr.querySelector('[data-mm-gw]');
        if (old) old.remove();
        return;
      }
      getCart(true).then(function (cart) {
        var line = wrapLine(cart);
        var others = otherCount(cart);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && cart.item_count > 0 && drawer.querySelector('.cart-item')) drawer.classList.remove('is-empty');

        if (line && others === 0) { setWrap(false, null); return; }
        hs.forEach(function (h) {
          var box = h.host.querySelector('[data-mm-gw]');
          if (others === 0) { if (box) box.remove(); return; }
          if (!box) {
            box = makeBox(!!line, (cart.attributes || {})[ATTR]);
            var ref = h.before && h.before.parentNode === h.host ? h.before : h.host.firstChild;
            h.host.insertBefore(box, ref);
          } else {
            var cb = box.querySelector('[data-mm-gw-toggle]');
            if (cb) cb.checked = !!line;
            var m = box.querySelector('.mm-gw__msg');
            if (m) m.hidden = !line;
            box.classList.remove('is-busy');
          }
        });
      });
    }, 120);
  }

  /* Ereignisse */
  var saveTimer = null;
  function saveMsg(ta) {
    var v = ta.value.trim();
    setAttr(v).then(function () {
      var s = ta.parentNode.querySelector('.mm-gw__saved');
      if (s) s.textContent = v ? T.saved : '';
    });
  }
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-mm-gw-msg]')) return;
    var ta = e.target;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () { saveMsg(ta); }, 700);
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches) return;
    if (t.matches('[data-mm-gw-msg]')) { clearTimeout(saveTimer); saveMsg(t); }
    if (t.matches('[data-mm-gw-toggle]')) {
      var box = t.closest('[data-mm-gw]');
      var msg = box && box.querySelector('.mm-gw__msg');
      if (msg) msg.hidden = !t.checked;
      setWrap(t.checked, box);
    }
  });

  /* Auf Neuzeichnen des Warenkorbs reagieren (eigene Änderungen ignorieren) */
  function isOwn(m) {
    var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
    if (el && el.closest && el.closest('[data-mm-gw]')) return true;
    if (m.addedNodes.length && Array.prototype.every.call(m.addedNodes, function (n) { return n.nodeType === 1 && n.hasAttribute && n.hasAttribute('data-mm-gw'); })) return true;
    if (m.removedNodes.length && !m.addedNodes.length && Array.prototype.every.call(m.removedNodes, function (n) { return n.nodeType === 1 && n.hasAttribute && n.hasAttribute('data-mm-gw'); })) return true;
    return false;
  }
  var mo = new MutationObserver(function (muts) {
    if (muts.every(isOwn)) return;
    sync();
  });
  function start() {
    var d = document.querySelector('cart-drawer');
    if (d) mo.observe(d, { childList: true, subtree: true });
    var items = document.getElementById('main-cart-items');
    if (items) mo.observe(items, { childList: true, subtree: true });
    var foot = document.getElementById('main-cart-footer');
    if (foot) mo.observe(foot, { childList: true, subtree: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
